<template>
  <div>
    <authentication-forms-container :image="image">
      <b-form @submit.prevent="onSubmit">
        <form-group :validations="$v.form.code">
          <div slot-scope="{ errors, invalid }">
            <b-form-group
                id="input-group-1"
                label="کد ارسال شده را وارد نمایید "
                label-for="input-1"
                description=""
                class="my-4 pt-5"
            >
              <span class="badge badge-primary px-2 mb-2"
              >زمان باقی مانده {{ timerCount }}
              </span>
              <b-form-input
                  id="input-1"
                  v-model="form.code"
                  type="text"
                  placeholder="کد ارسال شده را وارد نمایید"
                  :class="{ invalid }"
                  class="rounded-pill text-left"
              ></b-form-input>
              <form-errors-manager :errors="errors"/>
            </b-form-group>
          </div>
        </form-group>

        <b-button block pill type="submit" class="my-5 w-100" variant="primary"
        >تایید
        </b-button>
        <a
            class="text-decoration-none"
            href="#"
            v-if="timerCount === 0"
            @click.prevent="resendCellphoneVerificationCode"
        >ارسال مجدد کد</a
        >
      </b-form>
    </authentication-forms-container>
  </div>
</template>
<script>
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup.vue";
import {required, minLength} from "vuelidate/lib/validators";
import FormErrorsManager
  from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue";
import {mapGetters, mapActions} from "vuex";
import AuthenticationFormsContainer from "../../AuthenticationFormsContainer/AuthenticationFormsContainer.vue";

export default {
  name: "VerifiedCellphone1",
  components: {FormGroup, FormErrorsManager, AuthenticationFormsContainer},
  data() {
    return {
      form: {
        code: "",
      },
      timerEnabled: true,
      timerCount: 120,
    };
  },
  props: {
    image: {
      type: String,
      default: require('../../assets/login.png')
    }
  },
  watch: {
    timerEnabled(value) {
      if (value) {
        setTimeout(() => {
          this.timerCount--;
        }, 1000);
      }
    },

    timerCount: {
      handler(value) {
        if (value > 0 && this.timerEnabled) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
  },
  validations: {
    form: {
      code: {required, minLength: minLength(4)},
    },
  },
  computed: {
    ...mapGetters({
      cellphon: "User/getUserCellphone",
    }),
  },
  methods: {
    ...mapActions({}),
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },

    onSubmit() {
      if (this.invalid()) {
        console.log("valid");

        this.$store.dispatch("Authentication/verifyCellphone", this.form);
      }
    },
    resendCellphoneVerificationCode() {
      let c = {cellphone: this.cellphon};

      this.$store.dispatch("Authentication/resendCellphoneVerificationCode", c);
      this.resetTimer();
    },

    play() {
      this.timerEnabled = true;
    },

    pause() {
      this.timerEnabled = false;
    },
    resetTimer() {
      this.timerCount = 120;
      this.timerEnabled = true;
    },
  },
};
</script>
<style scoped></style>